export const paragraphValidation = [
    (input) => input.trim().length < 10 ? 'Your message should be at least 10 letters' : null,
    (input) => input.trim().length > 170 ? 'Your message should not be more than 170 letters' : null,
    (input) => /^[a-z0-9 \- , . \n]+$/i.test(input) ? null : 'Only valid characters are allowed',
]